import React from "react";

const Modal = ({
  show,
  removeHeader,
  children,
  onClose,
  paddingNone,
  header,
  size,
  overflow,
}) => {
  if (show) {
    return (
      <>
        <div className="fixed inset-0 z-[9999999] flex ">
          <div className="absolute inset-0 bg-[#0000009d] backdrop-blur-md"></div>

          <div
            id="large-modal"
            className={`overflow-y-auto overflow-x-hidden flex flex-col ${
              size !== "full" && "items-center justify-center"
            }  fixed top-0 z-[9999999] w-full h-full`}
          >
            <div
              className={`relative bg-white  ${
                size === "full" ? "rounded-b-3xl" : "rounded-lg"
              } ${
                size === "lg"
                  ? "max-w-4xl"
                  : size === "full"
                    ? "max-w-full"
                    : size === "md"
                      ? "max-w-2xl"
                      : "max-w-[75vw]"
              } max-h-full pb-8`}
            >
              <div className="relative rounded-lg ">
                {!removeHeader && (
                  <div className="flex items-center justify-between p-3 ">
                    <h3 className="text-xl font-semibold text-gray-900 px-4">
                      {header}
                    </h3>
                    <button
                      type="button"
                      className="modal-close-btn"
                      onClick={onClose}
                    >
                      <svg
                        className="w-3 h-3"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 14"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                        />
                      </svg>
                      <span className="sr-only">Close modal</span>
                    </button>
                  </div>
                )}
                <div className={`mt-2 mx-4 ${overflow ? "" : "overflow-auto"}`}>
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

export default Modal;
